import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SwitchToggle from "../../../components/SwitchToggle";
import SearchBar from "../../../components/SearchBar";
import AddSubCategory from "../../../Modals/addsubcategory";

const ManageSubCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // 🔥 Updated rows as per Fitness APP
  const [rows] = useState([
    {
      id: 1,
      name: "Full Body",
      createdDate: "02-Jan-2025",
      status: true,
    },
    {
      id: 2,
      name: "Upper Body",
      createdDate: "05-Jan-2025",
      status: true,
    },
    {
      id: 3,
      name: "Lower Body",
      createdDate: "06-Jan-2025",
      status: true,
    },
    {
      id: 4,
      name: "Core",
      createdDate: "08-Jan-2025",
      status: false,
    },
    {
      id: 5,
      name: "HIIT",
      createdDate: "10-Jan-2025",
      status: true,
    },
    {
      id: 6,
      name: "Dumbbell Strength",
      createdDate: "12-Jan-2025",
      status: true,
    },
    {
      id: 7,
      name: "Bodyweight",
      createdDate: "14-Jan-2025",
      status: false,
    },
    {
      id: 8,
      name: "Abs",
      createdDate: "16-Jan-2025",
      status: true,
    },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      <div className="main_title">
        <h1>Manage Sub Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-categories")}>
            Manage Categories
          </button>{" "}
          - Manage Sub Categories
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Sub-Categories..."
            />
          </div>

          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
              <AddIcon /> Add Sub-Category
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Sub-Category Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <a
                      href={`/manage-sub-categories/detail/${row.id}`}
                      className="click_action"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/manage-sub-categories/detail/${row.id}`);
                      }}
                    >
                      <b>{row.name}</b>
                    </a>
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell>
                    <SwitchToggle checked={row.status} />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </div>

      <AddSubCategory open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default ManageSubCategories;
